/* eslint-disable no-undef, import/no-extraneous-dependencies */
const { debounce } = require('lodash');

$(() => {
	const $window = $(window);
	const mobileBreakpoint = 768;

	/**
	 * compare the window width and update logo slider slick status accordingly.
	 */
	const updateLogoSlider = () => {
		const $slider = $('.r-logslr-l3--cnvsgt1 .bs-logo-slider__inner');

		if ($window.width() >= mobileBreakpoint) {
			if ($slider.hasClass('slick-initialized')) {
				$slider.slick('unslick');
			}
		} else if (!$slider.hasClass('slick-initialized')) {
			$slider.slick();
		}
	};

	// Check window size and unslick logo slider on load.
	$window.on('load', updateLogoSlider);

	// Update logo slider on resize
	$window.on('resize', debounce(updateLogoSlider, 500));
});
